// import React, { useState } from "react";
// import "./serviceList.css";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
// import Brick from "../../../assets/newMaterial/brick.jpeg";
// import cement from "../../../assets/newMaterial/cement.jpeg";
// import ChapadiKal from "../../../assets/newMaterial/chapadikallu.jpeg";
// import DoorsWindows from "../../../assets/newMaterial/door.jpeg";
// import Electricals from "../../../assets/newMaterial/electrician.jpeg";
// import GlassStill from "../../../assets/newMaterial/glass.jpeg";
// import Hardware from "../../../assets/material/hardware3.png";
// import Interior from "../../../assets/material/intiriarpage1.jpeg";
// import jalli from "../../../assets/newMaterial/jalli.jpeg";
// import msand from "../../../assets/newMaterial/sand.jpeg";
// import soil from "../../../assets/newMaterial/soil.jpeg";
// import steel from "../../../assets/material/Steel.webp";
// import solar from "../../../assets/newMaterial/solar.jpeg";
// import painter from "../../../assets/newMaterial/paint.jpeg";
// import pop from "../../../assets/newMaterial/pop.jpeg";
// import plumb from "../../../assets/newMaterial/plumber.jpeg";
// import tails from "../../../assets/newMaterial/tails.jpeg";
// import UseMediaQuery from "./../UseMediaQuery";

// const MaterialList = () => {
//   const isMobile = UseMediaQuery("(max-width:486px)");
//   const materialList = [
//     { img: cement, name: "Cement" },
//     { img: msand, name: "M Sand" },
//     { img: soil, name: "Soil" },
//     { img: steel, name: "Steel" },
//     { img: jalli, name: "Jalli" },
//     { img: Brick, name: "Brick" },

//     { img: Electricals, name: "Electricals" },
//     { img: GlassStill, name: "Glass And Steel" },

//     { img: Interior, name: "Interior" },
//     { img: pop, name: "POP" },
//     { img: DoorsWindows, name: "Doors And Windows" },
//     { img: painter, name: "Paint" },
//     { img: tails, name: "Tiles/ Marbles" },
//     { img: ChapadiKal, name: "Chapadi Kal" },
//     { img: solar, name: "Solor" },
//     { img: plumb, name: "Plumbing" },

//     { img: Hardware, name: "Hardware" },
//   ];

//   const [isFirstSlide, setIsFirstSlide] = useState(true);
//   const [isLastSlide, setIsLastSlide] = useState(false);

//   const NextArrow = ({ onClick }) => (
//     <div
//       className={`topCArrow topCNext ${isLastSlide ? "iconHidden" : ""}`}
//       onClick={onClick}
//     >
//       <IoIosArrowForward />
//     </div>
//   );

//   const PrevArrow = ({ onClick }) => (
//     <div
//       className={`topCArrow topCPrev ${isFirstSlide ? "iconHidden" : ""}`}
//       onClick={onClick}
//     >
//       <IoIosArrowBack />
//     </div>
//   );

//   const settings = {
//     infinite: false,
//     slidesToShow: 5,
//     slidesToScroll: 2,
//     pauseOnHover: true,
//     nextArrow: <NextArrow />,
//     prevArrow: <PrevArrow />,
//     responsive: [
//       { breakpoint: 1024, settings: { slidesToShow: 4 } },
//       { breakpoint: 768, settings: { slidesToShow: 3 } },
//       { breakpoint: 486, settings: { slidesToShow: 2.5 } },
//     ],
//     beforeChange: (current, next) => {
//       setIsFirstSlide(next === 0);
//       setIsLastSlide(next === materialList.length - 5);
//     },
//   };

//   return (
//     <>
//       <div className={isMobile ? "container-fluid mt-1" : "container mt-3"}>
//         {materialList?.length > 0 && (
//           <div className="row">
//             <h3 className="homehTag  my-xl-4 my-xxl-4 my-lg-4 my-md-2 my-sm-1 my-1">
//               Material Lists
//             </h3>
//             <div className="my-1">
//               <Slider {...settings}>
//                 {materialList?.map((item, i) => (
//                   <div key={i} className="serviceItem text-center my-1">
//                     <img
//                       src={item.img}
//                       alt={item.name}
//                       className="serviceImg"
//                     />
//                     <p className="serviceName mb-0">{item.name}</p>
//                   </div>
//                 ))}
//               </Slider>
//             </div>
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// export default MaterialList;

import React, { useState } from "react";
import "./serviceList.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import Brick from "../../../assets/newMaterial/brick.jpeg";
import cement from "../../../assets/newMaterial/cement.jpeg";
import ChapadiKal from "../../../assets/newMaterial/chapadikallu.jpeg";
import DoorsWindows from "../../../assets/newMaterial/door.jpeg";
import Electricals from "../../../assets/newMaterial/electrician.jpeg";
import GlassStill from "../../../assets/newMaterial/glass.jpeg";
import Hardware from "../../../assets/newMaterial/mate2.png";
import Interior from "../../../assets/material/intiriarpage1.jpeg";
import jalli from "../../../assets/newMaterial/jalli.jpeg";
import msand from "../../../assets/newMaterial/sand.jpeg";
import soil from "../../../assets/newMaterial/soil.jpeg";
import steel from "../../../assets/material/Steel.webp";
import solar from "../../../assets/newMaterial/solar.jpeg";
import painter from "../../../assets/newMaterial/paint.jpeg";
import pop from "../../../assets/newMaterial/pop.jpeg";
import plumb from "../../../assets/newMaterial/plumber.jpeg";
import tails from "../../../assets/newMaterial/tails.jpeg";
import UseMediaQuery from "./../UseMediaQuery";
const MaterialList = () => {
  const isMobile = UseMediaQuery("(max-width:486px)");
  const materialList = [
    { img: cement, name: "Cement" },
    { img: msand, name: "M Sand & P Sand" },
    { img: soil, name: "Soil" },
    { img: steel, name: "Steel" },
    { img: jalli, name: "Jalli" },
    { img: Brick, name: "Brick" },

    { img: Electricals, name: "Electricals" },
    { img: GlassStill, name: "Glass & Steel" },

    { img: Interior, name: "Interior" },
    { img: pop, name: "POP" },
    { img: DoorsWindows, name: "Doors & Windows" },
    { img: painter, name: "Paint" },
    { img: tails, name: "Tiles/ Marbles" },
    { img: ChapadiKal, name: "Chapadi Kal" },
    { img: solar, name: "Solar" },
    { img: plumb, name: "Plumbing" },

    { img: Hardware, name: "Hardware" },
  ];

  return (
    <>
      <div className="container-fluid serviceBgOne">
        <div
          className={
            isMobile
              ? "container-fluid mt-4 mb-4"
              : "container mt-3 mb-xl-5 mb-lg-5 mb-md-4 mb-sm-3"
          }
        >
          {materialList?.length > 0 && (
            <div className="row">
              <h3 className="homehTag mt-xl-4 mt-xxl-4 mt-lg-4 mt-md-3 mt-sm-3 mt-2">
                Material Lists
              </h3>
              <div className="col-12 d-flex flex-wrap  mb-xl-5 mb-lg-5 mb-md-4 mb-sm-3 mb-2">
                {materialList.map((item, i) => (
                  <div
                    key={i}
                    className="col-6 col-md-4 col-sm-4 col-lg-3 t-xl-3 mt-lg-3 mt-md-2 mt-2"
                  >
                    <div className="serviceItem text-center">
                      <img
                        src={item.img}
                        alt={item.name}
                        className="serviceImg"
                      />
                      <p className="serviceName mb-xl-0 mb-lg-0 mb-2 ">
                        {item.name}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default MaterialList;
